import React, { useEffect } from 'react';
// import ReactDOM from 'react-dom';
import success from '../../../imges/settled/mobile/success.png';
import './style/step3.less';

export default function () {
  // const other = () => <footer className='footer-bg'/>
  useEffect(() => {
    window.parent.postMessage({height: '14rem', type: 'height'},"*");
  }, []);

  return (
    <div className='settled-step3'>
      <img src={success} alt='成功图片'/>
      <p>恭喜！提交成功！</p>
      <p>之后我们将会安排专人与您洽谈合作事宜，谢谢！</p>
      {
        // ReactDOM.createPortal(other(), document.body)
      }
    </div>
  )
}